// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"a0959432","421":"2bdef3be","631":"976551f9","711":"683a81e5","770":"e960497a","950":"1afa3c74"}[chunkId] + ".chunk.js";
};